import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { initializeApp, logout } from '../store/slices/authSlice';

const AppInitializer = ({ children }) => {
  const dispatch = useDispatch();
  const { isLoading, isAuthenticated } = useSelector(state => state.auth);

  useEffect(() => {
    const hasToken = !!localStorage.getItem('token');
    // Always re-verify when a token exists so name/permissions match the database
    // (persisted auth leaves isAuthenticated true on refresh, which previously skipped refresh entirely).
    if (hasToken) {
      dispatch(initializeApp());
    } else if (isAuthenticated) {
      // Reconcile a broken/stale session: persisted state still says authenticated
      // but there is no token on disk. Clear it so protected routes redirect to login
      // instead of firing tokenless requests that 401.
      dispatch(logout());
    }
  }, [dispatch, isAuthenticated]);

  // Show loading while initializing
  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: '#f8f9fa'
      }}>
        <div style={{
          textAlign: 'center',
          padding: '40px',
          background: 'white',
          borderRadius: '10px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
        }}>
          <div style={{
            width: '40px',
            height: '40px',
            border: '4px solid #f3f3f3',
            borderTop: '4px solid rgb(52, 152, 219)',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 20px'
          }}></div>
          <p style={{ color: '#666', margin: 0 }}>Initializing application...</p>
          <style>{`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      </div>
    );
  }

  return children;
};

export default AppInitializer; 